import React, { ReactNode } from 'react';
import { useBetaLabs } from '../../contexts/BetaLabsContext';

interface BetaLabsGateProps {
  children: ReactNode;
  featureKey?: string;
  fallback?: ReactNode;
}

/**
 * Component that conditionally renders children based on beta labs opt-in status
 * @param children - Content to render when beta labs is enabled
 * @param featureKey - Optional specific feature key to check (defaults to general beta labs enabled)
 * @param fallback - Optional content to render when beta labs is disabled
 */
const BetaLabsGate: React.FC<BetaLabsGateProps> = ({ 
  children, 
  featureKey, 
  fallback = null 
}) => {
  const { isBetaLabsEnabled, isFeatureEnabled } = useBetaLabs();

  // If a specific feature key is provided, check that feature
  // Otherwise, check general beta labs enabled status
  const shouldRender = featureKey 
    ? isFeatureEnabled(featureKey) 
    : isBetaLabsEnabled;

  return shouldRender ? <>{children}</> : <>{fallback}</>;
};

export default BetaLabsGate;
